import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import { fluid } from '@helpers/fluid';
import { contentStyles, h4 } from '@helpers/typography';
import styled from 'styled-components';
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(280, 160, 384, 252)}
`;
const Image = styled.img `
  ${imageCoverContainer()}

  border-top-left-radius: var(--borderRadius);
  border-top-right-radius: var(--borderRadius);
`;
const ContentWrapper = styled.div `
  padding: ${fluid(18, 26)} ${fluid(20, 30)} ${fluid(18, 30)};
`;
const Title = styled.h3 `
  ${h4};

  margin: 0;
`;
const Content = styled.div `
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(21, 24)};
  ${contentStyles};

  margin-top: ${fluid(8, 16)};
`;
const Container = styled.div `
  --shadow-color: 0deg 0% 0%;

  border-radius: var(--borderRadius);
  max-width: 580px;
  overflow: hidden;
  display: block;
  color: var(--fgColor);
  text-align: left;
  background-color: var(--bgColor);
  box-shadow: 0px 0.2px 0.3px hsl(var(--shadow-color) / 0.01),
    0px 0.8px 1.2px -0.1px hsl(var(--shadow-color) / 0.03),
    0px 1.4px 2px -0.2px hsl(var(--shadow-color) / 0.05),
    0px 2.3px 3.3px -0.3px hsl(var(--shadow-color) / 0.07),
    0px 4px 5.8px -0.4px hsl(var(--shadow-color) / 0.09);

  a& {
    text-decoration: none;

    ${Image} {
      ${transition('transform', 0.5)};
    }

    &:focus {
      outline: none;
    }

    &.focus-ring {
      outline: auto;
      outline-offset: 5px;
    }

    &.focus-ring,
    &:hover {
      ${Image} {
        transform: scale(1.15);
      }
    }
  }
`;
const ContentCardStyles = {
    Container,
    Content,
    ContentWrapper,
    Image,
    ImageWrapper,
    Title,
};
export default ContentCardStyles;
